export default "__VITE_ASSET__C__P$oyk__"